
import React from 'react';
import { ClipboardCheck, TruckIcon, Box, BarChart, Users } from 'lucide-react';
import TranslatedText from '@/TranslatedText';

const steps = [
  {
    id: 1,
    title: 'Apply to Sell',
    description: 'Submit your business information and product details for review by our seller team.',
    icon: <ClipboardCheck className="h-8 w-8 text-ahavex-blue" />
  },
  {
    id: 2,
    title: 'Product Approval',
    description: 'Our team reviews your products for quality and fit with our marketplace standards.',
    icon: <Box className="h-8 w-8 text-ahavex-blue" />
  },
  {
    id: 3,
    title: 'Distribution Setup',
    description: 'We arrange logistics for collecting your products and distributing them to retailers or end customers.',
    icon: <TruckIcon className="h-8 w-8 text-ahavex-blue" />
  },
  {
    id: 4,
    title: 'Sales & Analytics',
    description: 'Track your product performance and sales through our dedicated seller dashboard.',
    icon: <BarChart className="h-8 w-8 text-ahavex-blue" />
  },
  {
    id: 5,
    title: 'Growth & Support',
    description: 'Get ongoing support and opportunities to expand your reach across new markets.',
    icon: <Users className="h-8 w-8 text-ahavex-blue" />
  }
];

const PartnershipSteps: React.FC = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-ahavex-blue mb-4">
            <TranslatedText text="How the Partnership Works" />
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            <TranslatedText 
              text="We act as the bridge between you and the consumers. Here's how our partnership process works:"
            />
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.slice(0, 3).map((step) => (
            <div key={step.id} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="bg-blue-50 rounded-full w-16 h-16 flex items-center justify-center mb-4 mx-auto">
                {step.icon}
              </div>
              <h3 className="text-xl font-semibold text-center mb-3">
                <TranslatedText text={step.title} />
              </h3>
              <p className="text-gray-600 text-center">
                <TranslatedText text={step.description} />
              </p>
            </div>
          ))}
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 mt-8">
          {steps.slice(3).map((step) => (
            <div key={step.id} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="bg-blue-50 rounded-full w-16 h-16 flex items-center justify-center mb-4 mx-auto">
                {step.icon}
              </div>
              <h3 className="text-xl font-semibold text-center mb-3">
                <TranslatedText text={step.title} />
              </h3>
              <p className="text-gray-600 text-center">
                <TranslatedText text={step.description} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnershipSteps;
